export const IS_PRODUCTION =
  process.env.REACT_APP_API_URL?.startsWith('https://prodapi.remin.no') ?? false
